export enum CacheKeys {
  DEPOTS = "depots",
  DRIVERS = "drivers",
  VEHICLES = "vehicles",
  CALCULATIONS = "calculations",
  ORG_SETTINGS = "orgSettings",
  SCHEDULED_JOURNEYS = "scheduledJourneys",
  LEZS = "lezs",
  PENDING_LICENCE_PURCHASE = "purchaseLicence",
}
